const e = {
  name: "Mobile",
  dimensions: { width: 14, height: 23 },
  content: `
    <path fill="currentColor" stroke="none" d="M7 6.75C7.55228 6.75 8 6.30228 8 5.75C8 5.19772 7.55228 4.75 7 4.75C6.44772 4.75 6 5.19772 6 5.75C6 6.30228 6.44772 6.75 7 6.75Z"/>
    <rect fill="none" stroke="currentColor" x="1" y="1.75" width="12" height="20" rx="2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  `
};
export {
  e as Mobile
};
